var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundLinesThird = function SvgSoundLinesThird(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1425 470"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M247.24 1v596.58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M273.825 63.144v472.293"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M300.41 88.001V510.58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__d)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M326.994 38.286v522.008"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__e)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M353.58 13.429V585.15"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__f)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M380.165 112.669v372.863"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__g)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M406.749 174.812v248.575"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__h)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M433.335 149.955v310.719"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__i)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M459.919 212.098v186.431"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__j)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M486.505 236.957v124.287"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__k)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M513.09 187.241v223.718"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__l)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M539.674 162.384v285.861"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__m)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M566.26 199.67v211.289"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__n)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M592.845 199.67v211.289"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__o)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M996.936 101.618v395.414",
    opacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__p)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1023.52 52.19V546.46",
    opacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__q)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1050.11 27.478v543.694",
    opacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__r)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1076.69 151.045v296.561",
    opacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__s)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1103.28 175.569v247.134",
    opacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__t)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1129.86 150.856v308.917",
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__u)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1156.45 212.639V397.99",
    opacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__v)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1183.03 237.353V360.92",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__w)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1209.62 187.926v222.42",
    opacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__x)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1236.2 163.212v284.205",
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__y)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1262.79 200.282v210.064",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__z)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1289.37 200.282v210.064",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__A)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M965.034 18.652v570.136",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__B)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M938.449 80.623v446.193",
    opacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__C)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M911.864 105.412v396.616",
    opacity: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__D)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M885.279 55.835v495.77",
    opacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__E)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M858.694 31.046v545.348",
    opacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__F)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M832.109 117.617v371.828"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__G)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M805.525 179.587v247.886"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__H)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M778.94 154.8v309.856"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__I)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M752.354 216.771v185.913"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__J)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M725.769 241.559v123.942"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__K)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M699.184 191.982v223.096"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__L)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M672.599 167.193v285.068"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__M)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M646.015 142.405V477.05"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__N)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M619.429 253.953v111.549"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__O)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1422.34 247.945v123.567",
    opacity: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__P)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1395.76 198.517v222.421",
    opacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__Q)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1369.17 173.804v284.204",
    opacity: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__R)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1342.59 149.09v333.632",
    opacity: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__S)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1316 260.301v111.211",
    opacity: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__T)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M215.338 124.376v370.702"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__U)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M188.753 186.16v247.134"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__V)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M162.168 161.447v308.917"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__W)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M135.583 223.23v185.351"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__X)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M108.998 247.944v123.567"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__Y)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M82.413 198.516v222.421"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__Z)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M55.828 173.803v284.204"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__aa)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M29.243 149.09v333.631"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLinesThird_svg__ab)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.659 260.3v111.211"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__a",
    x1: 247.24,
    x2: 247.24,
    y1: 1,
    y2: 597.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__b",
    x1: 273.825,
    x2: 273.825,
    y1: 63.144,
    y2: 535.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__c",
    x1: 300.41,
    x2: 300.41,
    y1: 88.001,
    y2: 510.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__d",
    x1: 326.994,
    x2: 326.994,
    y1: 38.286,
    y2: 560.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__e",
    x1: 353.58,
    x2: 353.58,
    y1: 13.429,
    y2: 585.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__f",
    x1: 380.165,
    x2: 380.165,
    y1: 112.669,
    y2: 485.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__g",
    x1: 406.749,
    x2: 406.749,
    y1: 174.812,
    y2: 423.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__h",
    x1: 433.335,
    x2: 433.335,
    y1: 149.955,
    y2: 460.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__i",
    x1: 459.919,
    x2: 459.919,
    y1: 212.098,
    y2: 398.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__j",
    x1: 486.505,
    x2: 486.505,
    y1: 236.957,
    y2: 361.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__k",
    x1: 513.09,
    x2: 513.09,
    y1: 187.241,
    y2: 410.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__l",
    x1: 539.674,
    x2: 539.674,
    y1: 162.384,
    y2: 448.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__m",
    x1: 566.26,
    x2: 566.26,
    y1: 199.67,
    y2: 410.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__n",
    x1: 592.845,
    x2: 592.845,
    y1: 199.67,
    y2: 410.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__o",
    x1: 996.936,
    x2: 996.936,
    y1: 101.618,
    y2: 497.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__p",
    x1: 1023.52,
    x2: 1023.52,
    y1: 52.191,
    y2: 546.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__q",
    x1: 1050.11,
    x2: 1050.11,
    y1: 27.477,
    y2: 571.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__r",
    x1: 1076.69,
    x2: 1076.69,
    y1: 151.045,
    y2: 447.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__s",
    x1: 1103.28,
    x2: 1103.28,
    y1: 175.569,
    y2: 422.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__t",
    x1: 1129.86,
    x2: 1129.86,
    y1: 150.856,
    y2: 459.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__u",
    x1: 1156.45,
    x2: 1156.45,
    y1: 212.639,
    y2: 397.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__v",
    x1: 1183.03,
    x2: 1183.03,
    y1: 237.353,
    y2: 360.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__w",
    x1: 1209.62,
    x2: 1209.62,
    y1: 187.926,
    y2: 410.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__x",
    x1: 1236.2,
    x2: 1236.2,
    y1: 163.212,
    y2: 447.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__y",
    x1: 1262.79,
    x2: 1262.79,
    y1: 200.282,
    y2: 410.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__z",
    x1: 1289.37,
    x2: 1289.37,
    y1: 200.282,
    y2: 410.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__A",
    x1: 965.034,
    x2: 965.034,
    y1: 18.652,
    y2: 588.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__B",
    x1: 938.449,
    x2: 938.449,
    y1: 80.623,
    y2: 526.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__C",
    x1: 911.864,
    x2: 911.864,
    y1: 105.412,
    y2: 502.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__D",
    x1: 885.279,
    x2: 885.279,
    y1: 55.835,
    y2: 551.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__E",
    x1: 858.694,
    x2: 858.694,
    y1: 31.046,
    y2: 576.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__F",
    x1: 832.109,
    x2: 832.109,
    y1: 117.617,
    y2: 489.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__G",
    x1: 805.525,
    x2: 805.525,
    y1: 179.587,
    y2: 427.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__H",
    x1: 778.94,
    x2: 778.94,
    y1: 154.8,
    y2: 464.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__I",
    x1: 752.354,
    x2: 752.354,
    y1: 216.771,
    y2: 402.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__J",
    x1: 725.769,
    x2: 725.769,
    y1: 241.559,
    y2: 365.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__K",
    x1: 699.184,
    x2: 699.184,
    y1: 191.982,
    y2: 415.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__L",
    x1: 672.599,
    x2: 672.599,
    y1: 167.193,
    y2: 452.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__M",
    x1: 646.015,
    x2: 646.015,
    y1: 142.405,
    y2: 477.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__N",
    x1: 619.429,
    x2: 619.429,
    y1: 253.953,
    y2: 365.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__O",
    x1: 1422.34,
    x2: 1422.34,
    y1: 247.945,
    y2: 371.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__P",
    x1: 1395.76,
    x2: 1395.76,
    y1: 198.517,
    y2: 420.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__Q",
    x1: 1369.17,
    x2: 1369.17,
    y1: 173.804,
    y2: 458.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__R",
    x1: 1342.59,
    x2: 1342.59,
    y1: 149.09,
    y2: 482.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__S",
    x1: 1316,
    x2: 1316,
    y1: 260.301,
    y2: 371.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__T",
    x1: 215.338,
    x2: 215.338,
    y1: 124.376,
    y2: 495.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__U",
    x1: 188.753,
    x2: 188.753,
    y1: 186.16,
    y2: 433.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__V",
    x1: 162.168,
    x2: 162.168,
    y1: 161.447,
    y2: 470.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__W",
    x1: 135.583,
    x2: 135.583,
    y1: 223.23,
    y2: 408.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__X",
    x1: 108.998,
    x2: 108.998,
    y1: 247.944,
    y2: 371.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__Y",
    x1: 82.413,
    x2: 82.413,
    y1: 198.516,
    y2: 420.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__Z",
    x1: 55.828,
    x2: 55.828,
    y1: 173.803,
    y2: 458.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__aa",
    x1: 29.243,
    x2: 29.243,
    y1: 149.09,
    y2: 482.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLinesThird_svg__ab",
    x1: 2.659,
    x2: 2.659,
    y1: 260.3,
    y2: 371.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })))));
};
export default SvgSoundLinesThird;